import React from 'react';
import SuperAdminLayout from '@/components/admin/super-admin-layout';
import EmailSettingsPage from './email-settings';

export default function EmailPage() {
  return (
    <div className="min-h-screen bg-slate-50">
      <SuperAdminLayout>
        <EmailSettingsPage />
      </SuperAdminLayout>
    </div>
  );
}